/**
 * Google Analytics 4 (gtag.js), sin aviso de consentimiento: decision del
 * cliente del 02-10-2026. La politica de privacidad lo declara (seccion 5).
 *
 * Solo se carga si el build trae `VITE_ID_ANALYTICS`, que entra unicamente en
 * el build de produccion (`deploy.yml`): desarrollo nunca le manda datos a la
 * propiedad real. Tampoco en el backoffice: la tienda no enlaza al panel, asi
 * que quien entra a `/admin` llega con una carga completa y aca se corta.
 *
 * Las vistas de pagina de la SPA las mide la medicion mejorada de GA ("cambios
 * del historial de navegacion"), configurada en la propiedad, no aca.
 *
 * El `token` de la confirmacion de pago abre el comprobante (PAG-04) y llega
 * con una carga completa desde Webpay: se quita de la URL que se informa. La
 * propiedad ademas lo redacta (Administrar → Flujos de datos → Ocultar datos).
 */
const ID_ANALYTICS = import.meta.env.VITE_ID_ANALYTICS;

/** Parametros de la URL que nunca salen hacia Google. */
const PARAMETROS_PRIVADOS = ['token'];

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

function urlInformable(): string {
  const url = new URL(window.location.href);
  for (const parametro of PARAMETROS_PRIVADOS) url.searchParams.delete(parametro);
  url.hash = '';
  return url.toString();
}

/** Si GA se cargo en esta visita: sin eso, `enviarEvento` no hace nada. */
let activo = false;

// gtag.js exige el objeto `arguments`, no un arreglo: con `...args` no mide nada.
function gtag(..._args: unknown[]): void {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

/**
 * Un evento propio de la tienda (`medicion/eventos.ts`). Lleva la URL ya
 * limpia: sin `page_location`, gtag pondria la de la barra, y en la
 * confirmacion de pago esa trae el `token`.
 */
export function enviarEvento(nombre: string, parametros: Record<string, unknown>): void {
  if (!activo) return;
  gtag('event', nombre, { ...parametros, page_location: urlInformable() });
}

export function iniciarAnalytics(): void {
  if (ID_ANALYTICS === undefined || ID_ANALYTICS === '') return;
  if (window.location.pathname.startsWith('/admin')) return;

  window.dataLayer = window.dataLayer ?? [];
  activo = true;
  gtag('js', new Date());
  gtag('config', ID_ANALYTICS, { page_location: urlInformable() });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ID_ANALYTICS)}`;
  document.head.appendChild(script);
}
